import React from 'react';
import { View, Text, Pressable, HStack, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faBook, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
const MenuLinks = props => {
  const {
    isGuidelineModalOpen,
    setIsGuidelineModalOpen
  } = props;
  const MenuLinkFontAwesomeIcon = ({
    icon,
    style = {
      marginRight: 5
    }
  }) => {
    // 'rgb(131,139,144)'
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: icon,
      color: colors.menu.links.icon,
      style: style
    });
  };
  const theme = useTheme(),
    {
      colors
    } = theme;
  return /*#__PURE__*/React.createElement(View, {
    w: '100%',
    ml: 8,
    mb: 3,
    mt: 5
  }, /*#__PURE__*/React.createElement(Pressable, {
    marginBottom: 5,
    onPress: () => setIsGuidelineModalOpen(true)
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(MenuLinkFontAwesomeIcon, {
    icon: faBook
  }), /*#__PURE__*/React.createElement(Text, null, "Community Guidelines"))), /*#__PURE__*/React.createElement(Pressable, {
    marginBottom: 5,
    onPress: () => window.fcWidget && fcWidget.open()
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(MenuLinkFontAwesomeIcon, {
    icon: faCircleQuestion
  }), /*#__PURE__*/React.createElement(Text, null, "Need Tech Help?"))));
};
export default MenuLinks;
//# sourceMappingURL=MenuLinks.js.map